import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=bd457fb6&scoped=true"
import script from "./Accesses.vue?vue&type=script&lang=js"
export * from "./Accesses.vue?vue&type=script&lang=js"
import style0 from "./Accesses.vue?vue&type=style&index=0&id=bd457fb6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd457fb6",
  null
  
)

export default component.exports